import { Delete } from 'assets/Icons'
import { Modal, Tooltip } from 'components/Overlay'
import Spinner from 'components/Spinner'
import notification from 'helpers/notification'
import React, { Fragment, useState } from 'react'
import services from 'services/index'

const DeleteStudent = ({ id, filter, getStudents }) => {
	const [visibleDelete, setVisibleDelete] = useState(false)
	const [loading, setLoading] = useState(false)
	const deleteStudent = () => {
		const options = {
			id,
			onEnd: () => setLoading(false),
			onStart: () => setLoading(true),
			onError: () => notification('Error', { type: 'error' }),
			onSuccess: () => {
				getStudents(filter)
				notification("Muvaffaqiyatli o'chirildi", { type: 'success' })
				setVisibleDelete(false)
			},
		}
		services.students.deleteStudents(options)
	}
	return (
		<Fragment>
			<Tooltip title="O'chirish" distance={6}>
				<button className='delete-icon' onClick={() => setVisibleDelete(true)}>
					<Delete />
				</button>
			</Tooltip>
			<Modal
				onClose={() => setVisibleDelete(false)}
				onOpen={() => setVisibleDelete(true)}
				open={visibleDelete}
			>
				{loading ? (
					<div className='w-[450px] h-[227px] flex items-center justify-center'>
						<Spinner />
					</div>
				) : (
					<div className='py-[32px] px-[24px]'>
						<h4 className='text-[#292B32] dark:text-[#f2f2f2] text-[24px] font-bold m-0 text-center'>
							Ma’lumotni o‘chirish
						</h4>
						<p className='text-[#292B32] dark:text-[#f2f2f2] text-lg font-medium mx-0 mt-[16px] mb-[0] text-center'>
							Haqiqatan ham ushbu ma’lumotni o‘chirmoqchimisiz?
						</p>
						<div className='flex justify-center items-center mt-[24px]'>
							<button
								className='mute-btn mr-5 min-w-[150px]'
								onClick={() => setVisibleDelete(false)}
							>
								Bekor qilish
							</button>
							<button
								className='danger-btn min-w-[150px]'
								onClick={() => deleteStudent(id)}
							>
								Ha
							</button>
						</div>
					</div>
				)}
			</Modal>
		</Fragment>
	)
}

export default DeleteStudent
